export const selectOfflineContentStatus = (rootState, content) => {
    return rootState.offline.content[content.id];
};

export const isOfflineReady = rootState => {
    return rootState.offline.ready;
};

export const isConnected = rootState => {
    return rootState.offline.connected;
};

export const selectConnectedAt = rootState => {
    return rootState.offline.connectedAt;
};

export const isContentOffline = (rootState, contentId) => {
    const { content } = rootState.offline;
    const item = content[contentId];
    // Only include completely downloaded content
    return item != null && item.totalPages === item.localPages;
};

export const selectDownloadingContentIds = rootState => {
    const { content } = rootState.offline;

    return (
        Object.keys(content)
            .filter(contentId => !isContentOffline(rootState, contentId))
            // Object keys are strings, so these need to be converted
            .map(Number)
    );
};

export const selectOfflineContentIds = rootState => {
    const { content } = rootState.offline;

    return (
        Object.keys(content)
            .filter(contentId => isContentOffline(rootState, contentId))
            // Object keys are strings, so these need to be converted
            .map(Number)
    );
};



// WEBPACK FOOTER //
// ./src/selectors/offline.js